var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <div id="weather" class="div100" style="color: #fff;\r\n            /*background: #e74c3c;*/\r\n            /*padding: 10px;\r\n            margin: 30px auto;*/\r\n            /*width: 340px;*/\r\n            border-radius: 1px"></div> </div> </div> </div>';
}
return __p;
};
